import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classNames from "classnames";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";

var BaseItem = /*#__PURE__*/function (_Component) {
  _inherits(BaseItem, _Component);

  var _super = _createSuper(BaseItem);

  function BaseItem(props, context) {
    var _this;

    _classCallCheck(this, BaseItem);

    _this = _super.call(this, props, context);
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleBaseItemClick = _this.handleBaseItemClick.bind(_assertThisInitialized(_this));
    _this.toggleMenuExpand = _this.toggleMenuExpand.bind(_assertThisInitialized(_this));
    _this.ref = /*#__PURE__*/React.createRef();
    _this.state = {
      expanded: false
    };
    return _this;
  }

  _createClass(BaseItem, [{
    key: "handleBlur",
    value: function handleBlur(e) {
      // document.activeElement is IE11 fallback
      var relatedTarget = e.relatedTarget || document.activeElement; // React's `blur` event bubbles - it's actually closer to the `onfocusout`
      // event.
      //
      // We want to close the item when it loses focus. When something blurs, we
      // check the `relatedTarget` on the event, which corresponds to the newly
      // focused node. If it's contained inside the item, then the item still
      // has focus, and should stay open. Otherwise, we close it.

      if (this.ref.current && relatedTarget && this.ref.current.contains(relatedTarget)) {
        return;
      }

      document.body.classList.remove("u-bodyModalOpenNarrowOnly");
      this.setState({
        expanded: false
      });

      if (this.props.onMenuExpand) {
        this.props.onMenuExpand(false);
      }
    }
  }, {
    key: "handleBaseItemClick",
    value: function handleBaseItemClick(e) {
      e.preventDefault();

      if (this.props.onClick) {
        this.props.onClick();
      } else {
        this.toggleMenuExpand();
      }
    }
  }, {
    key: "toggleMenuExpand",
    value: function toggleMenuExpand() {
      window.scrollTo(0, 0);

      if (this.state.expanded) {
        document.body.classList.remove("u-bodyModalOpenNarrowOnly");
      } else {
        document.body.classList.add("u-bodyModalOpenNarrowOnly");
      }

      var expanded = !this.state.expanded;
      this.setState({
        expanded: expanded
      });

      if (this.props.onMenuExpand) {
        this.props.onMenuExpand(expanded);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var anchorProps = {};
      var getClassName = getClassNameFactory("GlobalHeaderBaseItem");
      var AnchorElementType = "a";

      if (this.props.children || !this.props.href) {
        AnchorElementType = "button";
        anchorProps.onClick = this.handleBaseItemClick;
        anchorProps.onKeyDown = this.props.onKeyDown;
      }

      if (this.props.children) {
        anchorProps["aria-haspopup"] = true;
        anchorProps["aria-expanded"] = this.state.expanded;
      } // We need to use a tabindex to ensure onBlur fires in Safari.


      anchorProps.tabIndex = 0;
      var chevron;

      if (this.props.children && this.state.expanded) {
        chevron = /*#__PURE__*/React.createElement(ChevronUpIcon, null);
      } else if (this.props.children && !this.state.expanded) {
        chevron = /*#__PURE__*/React.createElement(ChevronDownIcon, null);
      }

      var renderIcon = function renderIcon() {
        return /*#__PURE__*/React.createElement("div", {
          className: getClassName({
            descendantName: "linkIcon"
          })
        }, _this2.props.icon);
      };

      return /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          modifiers: classNames({
            dropdown: this.props.children,
            narrow: typeof this.props.narrow === "undefined" ? React.Children.count(this.props.children) === 1 : this.props.narrow
          }),
          states: classNames({
            expanded: this.state.expanded
          })
        }),
        "data-href": this.props.href,
        "data-label": this.props.label,
        "data-long-label": this.props.longLabel,
        "data-ariaLabel": this.props.ariaLabel,
        "data-link-language": this.props.linkLanguage,
        "data-narrow": this.props.narrow,
        "data-rehydratable": getRehydratableName(BaseItem.displayName),
        onBlur: this.handleBlur,
        ref: this.ref
        /**
         * tabIndex required so as to be blurable but not selectable,
         * we rely upon blur for closing menu when releasing focus.
         */
        ,
        tabIndex: "-1"
      }, /*#__PURE__*/React.createElement(AnchorElementType, _extends({
        lang: this.props.linkLanguage,
        className: getClassName({
          descendantName: "link"
        }),
        href: this.props.href,
        "aria-label": this.props.ariaLabel
      }, anchorProps), this.props.leftSideIcon && this.props.icon && renderIcon(), this.props.label && /*#__PURE__*/React.createElement("span", {
        className: getClassName({
          descendantName: "linkLabel"
        })
      }, this.props.label), (this.props.longLabel || this.props.label) && /*#__PURE__*/React.createElement("span", {
        className: getClassName({
          descendantName: "longLinkLabel"
        })
      }, this.props.longLabel || this.props.label), !this.props.leftSideIcon && this.props.icon && renderIcon(), chevron && /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "linkChevron"
        })
      }, chevron)), this.props.children && /*#__PURE__*/React.createElement("div", {
        tabIndex: "-1",
        className: getClassName({
          descendantName: "content"
        }),
        role: "menu"
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "contentInner"
        })
      }, this.props.children)));
    }
  }]);

  return BaseItem;
}(Component);

_defineProperty(BaseItem, "displayName", "GlobalHeader.BaseItem");

_defineProperty(BaseItem, "propTypes", {
  /**
   * The children to show in this `BaseItem`'s menu
   */
  children: PropTypes.node,

  /**
   * A destination that this `BaseItem` links to. Acts as a fallback href if children are specified.
   */
  href: PropTypes.string,

  /**
   * Icon node. Should be an icon from `@dcl/icons`.
   */
  icon: PropTypes.node,

  /**
   * Display icon on the left side of the item.
   */
  leftSideIcon: PropTypes.bool,

  /**
   * The label to show on this BaseItem.
   */
  label: PropTypes.node,

  /**
   * A long variant of the label to show on this BaseItem. This will only be shown above narrow breakpoints, and will override `label`.
   */
  longLabel: PropTypes.node,

  /**
   * This label will be used as the aria-label for the anchor element.
   */
  ariaLabel: PropTypes.string,

  /**
   * A language of the anchor element.
   */
  linkLanguage: PropTypes.string,

  /**
   * Narrow variant of the menu on desktop. Used for single column menus. If this is omitted, `BaseItem` will do its best to set this automatically.
   */
  narrow: PropTypes.bool,

  /**
   * On click function. Cannot be used when BaseItem contains children.
   */
  onClick: PropTypes.func,

  /**
   * onKeyDown listener for menu button. Has no effect when item does not have children.
   */
  onKeyDown: PropTypes.func,

  /**
   * Event listener for the case when menu is expanded/collapsed. Status (collapsed/expanded) is provided as an argument (boolean value).
   */
  onMenuExpand: PropTypes.func
});

export default BaseItem;